import arrayMove from 'array-move';
import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';

import { useActions } from '@mssgme/hooks';
import { ProductAdminItem } from '../../../../../UI';
import styles from './ProductsListDraggable.scss';

const SortableItem = SortableElement(({ product, draggable }) => (
    <li key={product._id} className={styles.listItem}>
        <ProductAdminItem
            tag={Link}
            product={product}
            to={`/p/products/${product._id}`}
            title={product.name}
            hasDragHandle={draggable}
        />
    </li>
));

const SortableList = SortableContainer(({ products, draggable }) => (
    <ul className={styles.productsList}>
        {products.map((product, index) => (
            <SortableItem
                key={product.id}
                index={index}
                product={product}
                disabled={!draggable}
                draggable={draggable}
            />
        ))}
    </ul>
));

export default function ProductsListDraggable({ products, collectionId, draggable }) {
    const actions = useActions();
    const [items, setProducts] = useState([]);
    const [isFetching, setIsFetching] = useState(false);

    const onSortEnd = async ({ oldIndex, newIndex }) => {
        const product1Id = items[oldIndex].id;
        const product2Id = items[newIndex].id;

        setProducts((prevItems) => arrayMove(prevItems, oldIndex, newIndex));

        if (oldIndex !== newIndex) {
            await actions.api.products.sort({
                payload: { product1Id, product2Id, collectionId, limit: products.length },
            });
        }

        setIsFetching(false);
    };

    useEffect(() => {
        setProducts(products);
    }, [products]);

    return (
        <div className={cn({ [styles.root]: true, [styles.fetching]: isFetching })}>
            <SortableList
                products={items}
                axis="y"
                lockAxis="y"
                onSortEnd={onSortEnd}
                helperClass={styles.sortable}
                draggable={draggable}
                shouldCancelStart={(e) => {
                    if (e.target.dataset.element !== 'drag-handle') {
                        return true;
                    }
                }}
            />
        </div>
    );
}

ProductsListDraggable.propTypes = {
    products: PropTypes.array.isRequired,
    collectionId: PropTypes.string.isRequired,
    draggable: PropTypes.bool.isRequired,
};

ProductsListDraggable.defaultProps = {
    draggable: true,
};
